// pitch-core
var angular = require('angular');

require('@sonyatv/pitchuibundle');

// satv dependencies
require('../../src/AppBundle/Resources/js');
require('../../src/MediaClientBundle/Resources/js');
require('../../src/SearchClientBundle/Resources/js');
require('../../src/PlaylistClientBundle/Resources/js');
require('../../src/PlaylistPitchClientBundle/Resources/js');
require('../../src/SMFCoreClientBundle/Resources/js');
require('../../vendor/sonyatv/playlistclientbundle');
require('../../vendor/sonyatv/playlistpitchclientbundle');
require('../../vendor/sonyatv/searchclientbundle');
require('../../vendor/sonyatv/mediaclientbundle');
require('../../vendor/sonyatv/mediastatsclientbundle');
require('../../vendor/sonyatv/smfcoreclientbundle');

// From old bower_components
require('../vendor/fc-presentation/dist/js/fc-presentation.js');

// vendor dependencies
require('ui-router-metatags/dist/ui-router-metatags');
require('angular-scroll');
require('angular-hotkeys');
require('angular-ui-tinymce');
require('angular-google-analytics');

require('../css/playlist.css');
require('../css/instagram.css');


// WEBPACK FOOTER //
// ./assets/js/main.js